export const PRESET_TRIGGER_DELAYS = [
    // { value: 2, label: '2 Minutes' },
    // { value: 5, label: '5 Minutes' },
    // { value: 10, label: '10 Minutes' },
    { value: 15, label: '15 Minutes' },
    { value: 30, label: '30 Minutes' },
    { value: 45, label: '45 Minutes' },
    { value: 60, label: '1 Hour' },
    { value: 120, label: '2 Hours' },
    { value: 180, label: '3 Hours' },
    { value: 240, label: '4 Hours' },
    { value: 300, label: '5 Hours' },
    { value: 360, label: '6 Hours' },
    { value: 720, label: '12 Hours' },
    { value: 1440, label: '1 Day' },
    { value: 2880, label: '2 Days' },
    { value: 4320, label: '3 Days' },
    { value: 5760, label: '4 Days' },
    { value: 7200, label: '5 Days' },
    { value: 8640, label: '6 Days' },
    { value: 10080, label: '1 Week' },
    { value: 20160, label: '2 Weeks' },
    { value: 30240, label: '3 Weeks' },
    { value: 40320, label: '4 Weeks' },
    { value: 44200, label: '1 Month' },
    { value: 86400, label: '2 Month' },
    { value: -1, label: 'Custom' },
];